export const municipality = [
    'город Агидель',
    'город Кумертау',
    'город Нефтекамск',
    'город Октябрьский',
    'город Салават',
    'город Сибай',
    'город Стерлитамак',
    'город Уфа',
    'ЗАТО Межгорье',
    'Абзелиловский район',
    'Альшеевский район',
    'Архангельский район',
    'Аскинский район',
    'Аургазинский район',
    'Баймакский район',
    'Бакалинский район',
    'Балтачевский район',
    'Белебеевский район',
    'Белокатайский район',
    'Белорецкий район',
    'Бижбулякский район',
    'Бирский район',
    'Благоварский район',
    'Благовещенский район',
    'Буздякский район',
    'Бураевский район',
    'Бурзянский район',
    'Гафурийский район',
    'Давлекановский район',
    'Дуванский район',
    'Дюртюлинский район',
    'Ермекеевский район',
    'Зианчуринский район',
    'Зилаирский район',
    'Иглинский район',
    'Илишевский район',
    'Ишимбайский район',
    'Калтасинский район',
    'Караидельский район',
    'Кармаскалинский район',
    'Кигинский район',
    'Краснокамский район',
    'Кугарчинский район',
    'Кушнаренковский район',
    'Куюргазинский район',
    'Мелеузовский район',
    'Мечетлинский район',
    'Мишкинский район',
    'Миякинский район',
    'Нуримановский район',
    'Салаватский район',
    'Стерлибашевский район',
    'Стерлитамакский район',
    'Татышлинский район',
    'Туймазинский район',
    'Уфимский район',
    'Учалинский район',
    'Фёдоровский район',
    'Хайбуллинский район',
    'Чекмагушевский район',
    'Чишминский район',
    'Шаранский район',
    'Янаульский район'
]